/**
 * DemarrageExistanteController
 *
 * Mounted on /demarrage-existante.html. Twin of the creation controller —
 * the maquette is reproduced verbatim with every action button forcibly
 * `disabled` for EPIC-002 (real wiring lands in EPIC-018).
 *
 * Shell placeholders (sidebar foot, topbar avatar/org) are hydrated by
 * the global `app-header` controller. This controller is currently a
 * thin shell kept for the data-controller binding and for future EPIC-018
 * wiring (mandate signature, subscription pick).
 */

import BaseController from "./base_controller.js";

export default class DemarrageExistanteController extends BaseController {
    connect() {
        // Page logic lands in EPIC-018.
    }
}
